import { render } from "./RelatorioConstrucoes.vue?vue&type=template&id=841c30a8"
import script from "./RelatorioConstrucoes.vue?vue&type=script&lang=js"
export * from "./RelatorioConstrucoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__